import { IExtensionsSiteSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateExtensionsSiteSettingsParams {
  siteSettings: IExtensionsSiteSettings;
}

export type IUpdateExtensionsSiteSettingsResult = IResult & IExtensionsSiteSettings;

export class UpdateExtensionsSiteSettingsRequest extends Request<IUpdateExtensionsSiteSettingsParams, IUpdateExtensionsSiteSettingsResult> {
  constructor(params: IUpdateExtensionsSiteSettingsParams) {
    super('updateExtensionsSiteSettings', params);
  }
}
